// Wires server-rendered "Import files" buttons (`data-import-files="recordings"` etc.) to the
// Import files dialog. Vue pages call openImportFiles directly.
import { IMPORT_ENTRY_POINTS, openImportFiles } from './openImportFiles';

if (!(window as any).__hiikerImportFilesWired) {
  (window as any).__hiikerImportFilesWired = true;
  document.addEventListener('click', event => {
    const button = (event.target as Element | null)?.closest?.('[data-import-files]');
    if (!button) return;
    event.preventDefault();
    const start = IMPORT_ENTRY_POINTS[button.getAttribute('data-import-files') ?? 'none'] ?? IMPORT_ENTRY_POINTS.none;
    openImportFiles(start);
  });
}
